/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

function generateRandomId(length = 10) {
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * characters.length));
	}
	return result;
}

/**
 * initAccordions
 * TODO: https://van11y.net/accessible-accordion/ - try this out in the next iteration
 */

function initFaqs() {
	const faq = document.querySelectorAll('.wp-block-zp-faq .faq-toggle');
	for (let i = 0; i < faq.length; i++) {
		const uniqueId = generateRandomId();
		const headerId = `faq-header-${uniqueId}`;
		const panelId = `faq-panel-${uniqueId}`;

		const panel = faq[i].nextElementSibling;

		faq[i].id = headerId;
		faq[i].setAttribute('aria-controls', panelId);
		panel.id = panelId;
		panel.setAttribute('aria-labelledby', headerId);
		panel.setAttribute('role', 'region');

		faq[i].onclick = function () {
			const isExpanded = this.getAttribute('aria-expanded') === 'true';
			this.classList.toggle('is-active', !isExpanded);
			panel.classList.toggle('is-active', !isExpanded);
			this.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
			if (isExpanded) {
				panel.setAttribute('hidden', '');
			} else {
				panel.removeAttribute('hidden');
			}
		};
	}
}

window.addEventListener(
	'load',
	function () {
		initFaqs();
	},
	false
);
